<template>
  <a-drawer
    width="35%"
    :label-col="4"
    :wrapper-col="14"
    v-model:open="open"
    @close="onClose"
  >
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form ref="formRef" :model="form" :rules="rules">
      <a-form-item label="金额" name="money">
        <a-input-number
          v-model:value="money"
          :min="0"
          :step="0.01"
          style="width: 100%"
          placeholder="请输入金额"
        />
      </a-form-item>
      <!--      <a-form-model-item label="邮箱" prop="email" >-->
      <!--        <a-input v-model="form.email" placeholder="请输入邮箱" />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="密码，md5" prop="password" >-->
      <!--        <a-input v-model="form.password" placeholder="请输入密码，md5" />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="头像链接" prop="avatar" >-->
      <!--        <a-input v-model="form.avatar" placeholder="请输入头像链接" />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="昵称" prop="nickname" >-->
      <!--        <a-input v-model="form.nickname" placeholder="请输入昵称" />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="性别,0-保密 1-男 2-女" prop="sex" >-->
      <!--        <a-select placeholder="请选择性别,0-保密 1-男 2-女" v-model="form.sex">-->
      <!--          <a-select-option v-for="(d, index) in sexOptions" :key="index" :value="d.value" >{{ d.label }}</a-select-option>-->
      <!--        </a-select>-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="生日，格式1990-04-22" prop="birthday" >-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="用户个性签名" prop="userSign" v-if="formType === 1">-->
      <!--        <a-input v-model="form.userSign" placeholder="请输入用户个性签名" />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="邀请码" prop="invitationCode" >-->
      <!--        <a-input v-model="form.invitationCode" placeholder="请输入邀请码" />-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="是否推送 1-是 0-否" prop="isNotice" >-->
      <!--        <a-select placeholder="请选择是否推送 1-是 0-否" v-model="form.isNotice">-->
      <!--          <a-select-option v-for="(d, index) in isNoticeOptions" :key="index" :value="d.value" >{{ d.label }}</a-select-option>-->
      <!--        </a-select>-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="用户状态，1-正常，0禁用，禁用操作请注意清除token，同时不允许用户登录" prop="status" >-->
      <!--        <a-select placeholder="请选择用户状态，1-正常，0禁用，禁用操作请注意清除token，同时不允许用户登录" v-model="form.status">-->
      <!--          <a-select-option v-for="(d, index) in statusOptions" :key="index" :value="d.value" >{{ d.label }}</a-select-option>-->
      <!--        </a-select>-->
      <!--      </a-form-model-item>-->
      <!--      <a-form-model-item label="备注" prop="remark" v-if="formType === 1">-->
      <!--        <a-input v-model="form.remark" placeholder="请输入内容" type="textarea" allow-clear />-->
      <!--      </a-form-model-item>-->
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            保存
          </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form>
  </a-drawer>
</template>

<script setup>
import { ref, reactive } from 'vue'
import { message } from 'ant-design-vue'
import { addAccount } from '@/api/biz/account'

const props = defineProps({
  sexOptions: {
    type: Array,
    required: true,
  },
  isNoticeOptions: {
    type: Array,
    required: true,
  },
  statusOptions: {
    type: Array,
    required: true,
  },
})

const emit = defineEmits(['ok'])

const formRef = ref()
const submitLoading = ref(false)
const formTitle = ref('')
const formType = ref(1)
const open = ref(false)
const userId = ref(null)
const money = ref(0)

const form = reactive({
  id: null,
  mobile: null,
  email: null,
  password: null,
  avatar: null,
  nickname: null,
  sex: null,
  birthday: null,
  userSign: null,
  invitationCode: null,
  isNotice: null,
  status: null,
  createTime: null,
  remark: null,
})

const rules = {
  mobile: [
    { required: true, message: '手机号不能为空', trigger: 'blur' },
  ],
  nickname: [
    { required: true, message: '昵称不能为空', trigger: 'blur' },
  ],
  isNotice: [
    {
      required: true,
      message: '是否推送 1-是 0-否不能为空',
      trigger: 'change',
    },
  ],
  status: [
    {
      required: true,
      message:
        '用户状态，1-正常，0禁用，禁用操作请注意清除token，同时不允许用户登录不能为空',
      trigger: 'change',
    },
  ],
}

function onClose() {
  open.value = false
}

function cancel() {
  open.value = false
  reset()
}

function reset() {
  formType.value = 1
  Object.assign(form, {
    id: null,
    mobile: null,
    email: null,
    password: null,
    avatar: null,
    nickname: null,
    sex: null,
    birthday: null,
    userSign: null,
    invitationCode: null,
    isNotice: null,
    status: null,
    createTime: null,
    remark: null,
  })
  userId.value = null
  money.value = 0
}

function handleAdd(row) {
  reset()
  formType.value = 1
  open.value = true
  formTitle.value = '充值'
}

function handleUpdate(row, ids) {
  reset()
  formType.value = 2
  formTitle.value = '充值'
  const id = row ? row.id : ids
  userId.value = id
  open.value = true
}

async function submitForm() {
  try {
    await formRef.value.validate()
    submitLoading.value = true
    await addAccount({
      userId: userId.value,
      money: money.value,
    })
    message.success('充值成功', 3)
    open.value = false
    emit('ok')
  } catch (error) {
    return false
  } finally {
    submitLoading.value = false
  }
}

defineExpose({
  handleAdd,
  handleUpdate,
})
</script>
